module.exports = __webpack_public_path__ + "static/media/message.a7674b51.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/notifications/message.ogg
// module id = 2779
// module chunks = 0